export class PermissionGroup {
    ID: number;
    Description: string;
    Status: number;
    PermissionsXML: string;
}
